import { render, staticRenderFns } from "./SummaryAccountsSellers.vue?vue&type=template&id=99ef8f7c&scoped=true"
import script from "./SummaryAccountsSellers.vue?vue&type=script&lang=js"
export * from "./SummaryAccountsSellers.vue?vue&type=script&lang=js"
import style0 from "./SummaryAccountsSellers.vue?vue&type=style&index=0&id=99ef8f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ef8f7c",
  null
  
)

export default component.exports